function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.058 11.145H9.55a.492.492 0 00-.492.492v5.246a.492.492 0 00.492.492h9.508a.492.492 0 00.492-.492v-5.246a.492.492 0 00-.492-.492zm-.492 5.246h-8.525v-4.262h8.525z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.763 18.033a.492.492 0 00-.492.492v.492H3.484V.984h7.541v4.754a.492.492 0 00.492.492h4.755v3.771a.492.492 0 00.984 0V5.739a.481.481 0 00-.055-.221l-.01-.019a.481.481 0 00-.083-.111L11.866.145a.494.494 0 00-.1-.078L11.74.053a.508.508 0 00-.12-.043h-.005a.469.469 0 00-.091-.009H3.333a.826.826 0 00-.826.825v18.35a.826.826 0 00.826.825h13.109a.821.821 0 00.82-.82v-.655a.492.492 0 00-.499-.493zM12.008 5.246V1.68l3.567 3.566z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.862 16.065a.492.492 0 00.492-.492v-.492h.178a1.246 1.246 0 001.133-1.318 1.22 1.22 0 00-1.148-1.3h-.656a.492.492 0 00-.492.492v2.623a.492.492 0 00.493.487zm.82-2.3c0 .212-.105.333-.164.334h-.164v-.656h.164c.066-.001.164.113.164.321zM16.435 16.065a.492.492 0 00.492-.492v-.82h.492a.492.492 0 100-.983h-.492v-.328h.82a.492.492 0 100-.983h-1.311a.492.492 0 00-.492.492v2.623a.492.492 0 00.491.491zM13.484 16.065h.688a1.445 1.445 0 001.443-1.443v-.72a1.445 1.445 0 00-1.443-1.443h-.688a.492.492 0 00-.492.492v2.623a.492.492 0 00.492.491zm.492-2.623h.2a.46.46 0 01.46.46v.72a.461.461 0 01-.46.46h-.2z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgFilePdf = function SvgFilePdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFilePdf, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/FilePdf.dcee281c.svg";
export { ForwardRef as ReactComponent };